import React from 'react'
import Paper from 'material-ui/Paper';

import { schedule as ROLES_CONFIG } from '../../../../config/roles';

import NewSchedule from '../../../../components/schedule/NewSchedule';
import ListSchedules from '../../../../components/schedule/ListSchedules';

export default class Schedule extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (
      <div id="content">
        <div className="row">
          {
            ROLES_CONFIG.newSchedule.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-11 col-11 ml-3-2vw mt-1vw p-0 h-100 customShadow" zDepth={3}>
                <NewSchedule />
              </Paper> 
            : null
          }
          {
            ROLES_CONFIG.scheduleList.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-11 col-12 ml-3-2vw mt-1vw p-0 h-100 customShadow" zDepth={3}>
                <ListSchedules />
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./routes/app/routes/schedule/Schedule.js